<template>
    <div class="bgWhite p15" style="padding-bottom: 20px; height: 310px;">
        <h4 class="fontNormal font16" style="margin-bottom: 10px">报告 · 市场分析</h4>
        <div class="mw-table-line">
            <div class="mw-table-row pointer" v-for="(item, index) in report_list" :key="index" @click="goReportPage(item.reportId)">
                <div>{{ item.reportTitle }}</div>
                <div>{{ item.reportDate }}</div>
            </div>
            
        </div>
    </div>
</template>

<script>
import { baseUrl, navigationUrl } from '../assets/js/common';
export default {
    name: 'RecordAnalysis',
    components: { },
    data () {
        return {
            report_list: [],
            hasReport: false
        }
    },
    mounted () {
        // 初始化内容
        this.findReportSortByUserFormat();
        this.findNaTree();
    },
    methods: {
        //页面操作
/* ***** 获取报告分析 - 唐宋100指数（周）报告  start ****************************** */

        // 获取权限
        findNaTree () {
            const self = this;
            const token_cyw = self.$cookies.get('token_cyw');
            let url = ``;
            if (token_cyw) {
                self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                    if (res_1.status == 200) {
                        url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=Y`;
                    } else {
                        url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=N`;
                    }
                    self.$get(url, {}).then(res => {
                        if (res.code == 0) {
                            res.data.forEach((item, index) => {
                                if (item.navigationName == '研报') {
                                    self.hasReport = true;
                                }
                            })
                        } else {
                            self.hasReport = false;
                        }
                    }).catch(err => {})
                })
            } else {
                url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=N`;
                self.$get(url, {}).then(res => {
                    if (res.code == 0) {
                        self.submenu_list_1 = [];
                        res.data.forEach((item, index) => {
                            if (item.navigationName == '研报') {
                                self.hasReport = true;
                            }
                        })
                    } else {
                        self.hasReport = false;
                    }
                }).catch(err => {
                })
            }
        },

        findReportSortByUserFormat () {
            const self = this;
            self.$get(`${baseUrl.online}/industria/reportSort/findReportSortByUserFormat`, {}).then(res => {
                if(res.code == 0) {
                    res.data.forEach((item, index) => {
                        if (item.sortName == '唐宋100指数（周）报告') {
                            self.searchReport(item.sortId);
                        }
                    })
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到报告分类信息');
            })
        },

        searchReport (reportSort) {
            const self = this;
            self.$post(`${baseUrl.online}/industria/report/searchReport/1/7`, {reportSort: reportSort}).then(res => {
                if (res.code == 0) {
                    self.report_list = res.data;
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到报告分类信息');
            })
        },


/* ***** 获取报告分析 - 唐宋100指数（周）报告  end ******************************** */
        goReportPage (id) {
            if (this.hasReport) {
                this.$router.push(`/home/reportDetail/${id}`)
            } else {
                this.$message({
                    message: '登录即可查看全部研报信息',
                    type: 'warning'
                })
            }
        }
    },
}
</script>

<style scoped>

</style>